import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/core';
import Popper from '@material-ui/core/Popper';

import { SparkleIcon } from 'assets/icons';

import Panel from './Panel';

const useStyles = makeStyles((theme) => {
  const { primary, deepBlue } = theme.palette;
  const tint = deepBlue.bg; // rgba(2, 44, 230, 0.05) — brand primary tint

  return createStyles({
    fab: {
      position: 'fixed',
      bottom: 24,
      right: 24,
      width: 56,
      height: 56,
      minHeight: 56,
      borderRadius: '50%',
      background: primary.main,
      color: primary.contrastText,
      boxShadow: `0 6px 20px ${deepBlue.hoverColor}, 0 0 0 8px ${tint}`,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1200,
      border: 'none',
      outline: 'none',
      transition: 'transform 160ms ease, box-shadow 160ms ease',
      '&:hover': {
        transform: 'scale(1.04)',
        boxShadow: `0 8px 24px ${deepBlue.hoverColor}, 0 0 0 10px ${tint}`,
      },
      '& svg': { width: 22, height: 22 },
      // Sparkle SVG ships with a hardcoded dark fill — bind it to currentColor
      // so it renders white on the brand button.
      '& svg path[fill="#222222"]': { fill: 'currentColor' },
    },
  });
});

const AskManualWidget = () => {
  const classes = useStyles();
  const { pathname } = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleToggle = useCallback((e) => {
    setAnchorEl((prev) => (prev ? null : e.currentTarget));
  }, []);

  const handleClose = useCallback(() => setAnchorEl(null), []);

  const open = Boolean(anchorEl);

  // The Chat page has its own Send button pinned to the bottom-right corner;
  // hide the launcher there so the FAB doesn't overlap it.
  if (pathname.replace(/\/$/, '').endsWith('/chat')) return null;

  return (
    <>
      <button
        type="button"
        className={classes.fab}
        onClick={handleToggle}
        aria-label="Ask the Manual"
      >
        <SparkleIcon />
      </button>
      {/* Popper (not Popover) so there's no modal backdrop: the panel stays
          open when you click elsewhere and the page remains interactive, so
          you can follow the instructions while it's open. Close it with the
          panel's X/minimize buttons or by tapping the launcher again. */}
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top-end"
        style={{ zIndex: 1300 }}
        modifiers={{
          offset: { enabled: true, offset: '0, 12' },
          preventOverflow: { enabled: true, boundariesElement: 'viewport' },
        }}
      >
        <Panel onClose={handleClose} onMinimize={handleClose} />
      </Popper>
    </>
  );
};

export default AskManualWidget;
export { AskManualWidget };
